(function () {
  'use strict';
  angular.module('cbl.finanza.mf').service('SchedaDossierSrvc', [
    '$http',
    '$state',
    'FinUserSrvc',
    'FIN_CONSTANTS',
    function ($http, $state, finUserSrvc, CONSTANTS) {
      // Variabile di input/output
      this.schedaDossierDTO = {};
      this.dossierValueDTO = {};
      this.userService = finUserSrvc;

      this.datasource = null;

      this.datasourceItalia = null;

      this.datasourceEstero = null;

      this.inputFormMovimenti = {
        startDate: null,
        endDate: null,
        isin: '',
        descrizione: ''
      };

      this.inputFormGraficoSaldo = {
        startDate: null,
        endDate: null
      };

      this.movimenti = null;
      this.allMovements = null;
      this.saldoDatasource = [];

      // Variabili del grafico
      this.chart = {
        dataset: [],
        series: [],
        labels: [],
        options: {}
      };

      /**
       * @ngdoc method
       * @name promiseCustomerData
       * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
       * @description Effettua la chiamata per ricevere il customerdata
       * @return {Promise} - Ritorna una promise contenente il customerdata
       */
      this.promiseCustomerData = function (rapporto) {
        return $http({
          method: 'GET',
          url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
          params: {
            rapporto: rapporto,
            schedaDossier: true
          }
        });
      };

      this.promiseDataRicontrattualizzazione = function (rapporto) {
        return $http({
          method: 'GET',
          url:
            CONSTANTS.REST_CUSTOMER +
            CONSTANTS.REST.RICONTRATTUALIZZAZIONE_DOSSIER +
            rapporto
        });
      };
      this.promiseTotaliConti = function (rapporto) {
        return $http({
          method: 'GET',
          url:
            CONSTANTS.REST_CUSTOMER +
            CONSTANTS.REST.TOTALI_CONTI +
            '/' +
            rapporto
        });
      };
      this.checkReportButtonIsEnabled = function (ndg) {
        return $http({
          method: 'GET',
          url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.GENERAL.USER,
          params: {
            ndg: ndg
          }
        });
      };
      this.promisereportEffe = function (codicePortafoglio) {
        return $http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.REPORT +
            '/' +
            codicePortafoglio
        });
      };
      this.promiseRischioESG = function () {
        return $http({
          method: 'GET',
          url: 'http://localhost:3000/recuperaPunteggioRischioCliente'
        });
      };
    }
  ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/schedaDossier/schedaDossierSrvc.js
 ** module id = 41
 ** module chunks = 1 2
 **/